/**
 * Fetches this section's own recommendations markup from Shopify's real
 * recommendations endpoint (routes.product_recommendations_url) — same
 * self-fetch pattern the native product-recommendations.liquid section
 * uses — then lifts just the rendered product cards into the track.
 * Real Shopify-computed recommendations, not a guessed related list.
 */
import { revealOnScroll } from '@theme/premium-motion';

const section = document.querySelector('[data-flv-related]');
const track = section?.querySelector('[data-flv-related-track]');

if (section instanceof HTMLElement && track) {
  const { url, productId, limit } = section.dataset;

  fetch(`${url}&product_id=${productId}&limit=${limit}&intent=related`)
    .then((response) => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedTrack = doc.querySelector('[data-flv-related-track]');
      if (fetchedTrack && fetchedTrack.childElementCount > 0) {
        track.innerHTML = fetchedTrack.innerHTML;
        revealOnScroll('.flv-product-related__slide', { y: 20, scale: 0.97, duration: 0.6, stagger: 0.06 });
      } else {
        section.remove();
      }
    })
    .catch(() => section.remove());

  const scrollByAmount = () => Math.min(track.clientWidth * 0.8, 600);
  section.querySelector('[data-flv-related-prev]')?.addEventListener('click', () => {
    track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
  });
  section.querySelector('[data-flv-related-next]')?.addEventListener('click', () => {
    track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
  });
}
